<template>
  <van-overlay :show="show" :z-index="1000" @click="show = false">
    <div class="wrapper">
      <img
        v-if="hasErrorImg"
        :src="vuexInitData.game_extra_config.emergency_qr"
        alt=""
      />
      <!-- <img src="@/assets/img/ajeeyoo.png" alt="" /> -->
    </div>
  </van-overlay>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      show: false,
    };
  },
  computed: {
    ...mapGetters(["vuexInitData"]),
    hasErrorImg() {
      return (
        this.vuexInitData.game_extra_config &&
        this.vuexInitData.game_extra_config.emergency_qr
      );
    },
  },
  beforeDestroy() {
    this.$eventBus.$off("showErrorModal");
  },
  mounted() {
    this.$eventBus.$on("showErrorModal", () => {
      if (this.hasErrorImg) {
        this.show = true;
      }
    });
  },
};
</script>
<style lang="less" scoped>
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  img {
    width: 80%;
    object-fit: contain;
  }
}
</style>
